import React from "react";

import "../css/manuales.css";
import ManualesTarjeta from "./ManualesTarjeta";

function Manuales() {
  return (
    <div className="Manuales">
      <div className="container mt-4 pb-4">
        <div className="text-center">
          <h2 className="">Manuales de servicio</h2>
          <p className="text-secondary">
            Ordenadas por importancia para su rapida busqueda
          </p>
        </div>

        <div className="row">
          <div className="col-md-6 p-2">
            <ManualesTarjeta
              titulo="atención al cliente y ventas"
              text="Principios y Tácticas para una Atención al Cliente y Ventas de Calidad."
              page="/manual"
            />
          </div>
          <div className="col-md-6 p-2">
            <ManualesTarjeta
              titulo="productos y servicios"
              text="Conocimiento y Manejo de Productos y Servicios en Vidón Bar."
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Manuales;
